import { create } from 'zustand';

interface DashboardRenderStore {
  isFirstRenderComplete: boolean;
  canEnableQueries: boolean;
  setFirstRenderComplete: () => void;
  enableQueries: () => void;
  reset: () => void;
}

/**
 * Store to track Dashboard render state and control when queries can execute
 * This prevents React Query from running during critical render phases
 */
export const useDashboardRenderStore = create<DashboardRenderStore>((set) => ({
  isFirstRenderComplete: false,
  canEnableQueries: false,  setFirstRenderComplete: () => {
    console.log('[DashboardRenderStore] First render completed');
    // Enable both states immediately to reduce loading phases
    set({ 
      isFirstRenderComplete: true,
      canEnableQueries: true 
    });
  },
  
  enableQueries: () => {
    console.log('[DashboardRenderStore] Force enabling queries');
    set({ canEnableQueries: true });
  },
  
  reset: () => {
    console.log('[DashboardRenderStore] Resetting render state');
    set({ 
      isFirstRenderComplete: false, 
      canEnableQueries: false 
    });
  },
}));
